import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";


export const opsBeam = createBeam(bifrost, "/kin/ops");
